import React, { Component } from 'react';
import PropTypes from 'prop-types';
import find from 'lodash/find';
import { connect } from 'react-redux';
import { getFooterInfo } from 'reducers/selectors/metadata';
import { converter } from '../../../helpers/converter';

class SecurityFooter extends Component {
  UNSAFE_componentWillMount() {
    this.privacyPolicy =
      converter.convertApaUnicode(this.props.translations, 'link_privacidad') ||
      '';
    this.securityService =
      converter.convertApaUnicode(
        this.props.translations,
        'registro_msg_seguridad_recibo_telmex',
      ) || '';
  }

  render() {
    const { skin, lang } = this.props.config;
    const item = find(
      this.props.footer.links.left,
      fData => fData.name === 'footer_link_politicas_privacidad',
    ) || { url: 'politicas_de_privacidad.html' };
    const url = '/politicas_de_privacidad';
    return (
      <div className="row padding-top-2">
        <div className="col-lg-5 col-md-4">
          <p className="pull-left text-center-sm">
            <i className="fa fa-lock" />
            {this.securityService}
          </p>
        </div>

        <div className="col-lg-7 col-md-8">
          <p className="pull-right text-center-sm">
            <a id="politicaPrivacidad" metrics="" href={url} target="_blank">
              {this.privacyPolicy}
            </a>
          </p>
        </div>
      </div>
    );
  }
}

SecurityFooter.propTypes = {
  config: PropTypes.object,
  translations: PropTypes.object,
};

const mapStateToProps = state => ({
  footer: getFooterInfo(state),
});

export default connect(mapStateToProps)(SecurityFooter);
